<script setup lang="ts">
import { ProfilePictureProps } from './types'

defineProps({
  avatarContent: null,
  isMinified: { type: Boolean },
  isMedium: { type: Boolean }
})
</script>

<template>
  <div
    class="profile-picture flex justify-center items-center"
    :class="{ 'minified': isMinified, 'medium': isMedium, 'expanded': !isMinified && !isMedium }"
  >
    <div
      v-if="avatarContent"
      class="content cdc-fw-500 font-mark items-center"
      data-test="profile-picture-content"
    >
      {{ avatarContent }}
    </div>

    <div
      v-else
      class="content items-center"
    >
      <MinifiedProfilePictureFallback v-if="isMinified" />
      <MediumProfilePictureFallback v-else-if="isMedium" />
      <ExpandedProfilePictureFallback v-else />
    </div>
    <slot />
  </div>
</template>

<style lang="scss" scoped>
@import '~vars';

.profile-picture {
  background: $american-silver;
  border-radius: 100px;
  flex: 0 0 auto;
}

.fallback {
  background: url('') no-repeat center;
  background-size: auto 100% !important;
}

.expanded {
  font-size: 27px;
  height: 72px;
  width: 72px;
}

.medium {
  font-size: 18px;
  height: 54px;
  width: 54px;
}

.minified {
  font-size: 15px;
  height: 48px;
  width: 48px;
}

.content {
  color: $white;
  font-style: normal;
  line-height: 125%;
  text-align: center;
}
</style>
